import { v4 as uuidv4 } from 'uuid';
import { normalizeHexColor } from './richText.js';
import { normalizeStoredImageItem } from './localImage.js';
import { LOCAL_ASSET } from './localAssets.js';
import { getMediaItemUrl } from './qiniuMedia.js';

export const IMAGE_GRID_TYPE = 'image-grid';
export const IMAGE_GRID_DEFAULT_HEIGHT = 130;
export const IMAGE_GRID_COL_COUNT = 3;
export const IMAGE_GRID_COL_GAP = 12;
/** H5 内容区参考宽度（375 屏宽 - 左右 0.3rem 边距） */
export const IMAGE_GRID_H5_CONTENT_WIDTH = 345;

const DEFAULT_TEXT_COLOR = '#333333';

const ITEM_PRESETS = [
	{ title: '成交记录' },
	{ title: '流量验证' },
	{ title: '项目筛选' },
];

export function createDefaultImageGridItem(preset = {}, index = 0) {
	return {
		id: uuidv4(),
		title: preset.title || '图片标题',
		image: {
			id: `image-grid-item-${uuidv4()}`,
			filename: 'demo.jpg',
			previewUrl: LOCAL_ASSET.imgGrid[index % LOCAL_ASSET.imgGrid.length],
			url: '',
			local: false,
		},
	};
}

export function createDefaultImageGridItems(count = 3) {
	const items = [];
	for (let i = 0; i < count; i += 1) {
		const preset = ITEM_PRESETS[i] || {};
		items.push(createDefaultImageGridItem(preset, i));
	}
	return items;
}

export function getImageGridDefaults() {
	return normalizeImageGridData({
		items: createDefaultImageGridItems(3),
	});
}

export function isImageGridBlock(blockType) {
	return blockType === IMAGE_GRID_TYPE;
}

export function getImageGridImageUrl(image) {
	if (!image) return '';
	return getMediaItemUrl(image);
}

function normalizeGridImage(image, fallback) {
	if (!image?.previewUrl && !image?.url) {
		return fallback ? { ...fallback } : null;
	}
	return normalizeStoredImageItem(image, fallback);
}

export function normalizeImageGridItem(item = {}, index = 0) {
	const fallback = createDefaultImageGridItem({}, index);
	return {
		id: item.id || uuidv4(),
		title: item.title || fallback.title,
		image: normalizeGridImage(item.image, fallback.image),
	};
}

export function normalizeImageGridItems(items = []) {
	if (!items.length) {
		return createDefaultImageGridItems(3);
	}
	return items.map((item, index) => normalizeImageGridItem(item, index));
}

export function normalizeImageGridData(data = {}) {
	const height = Number(data.imageHeight);
	return {
		items: normalizeImageGridItems(data.items),
		imageHeight: Number.isFinite(height) && height > 0
			? height
			: IMAGE_GRID_DEFAULT_HEIGHT,
		borderRadius: Number.isFinite(Number(data.borderRadius))
			? Math.max(0, Number(data.borderRadius))
			: 0,
		textColor: normalizeHexColor(data.textColor || DEFAULT_TEXT_COLOR),
	};
}

export function getImageGridRefColumnWidth(contentWidth = IMAGE_GRID_H5_CONTENT_WIDTH) {
	const gaps = IMAGE_GRID_COL_GAP * (IMAGE_GRID_COL_COUNT - 1);
	return (contentWidth - gaps) / IMAGE_GRID_COL_COUNT;
}

/** 按手机端单列参考宽度与设定高度计算宽高比，保证各容器下比例一致 */
export function getImageGridThumbAspectRatio(imageHeight = IMAGE_GRID_DEFAULT_HEIGHT) {
	const colWidth = getImageGridRefColumnWidth();
	const height = Number(imageHeight) || IMAGE_GRID_DEFAULT_HEIGHT;
	return `${colWidth} / ${height}`;
}

export function getImageGridItemStyle(data = {}, { h5 = false } = {}) {
	const normalized = normalizeImageGridData(data);
	const pxRatio = h5 ? 50 : 1;
	const radius = normalized.borderRadius;

	return {
		aspectRatio: getImageGridThumbAspectRatio(normalized.imageHeight),
		borderRadius: h5 ? `${radius / pxRatio}rem` : `${radius}px`,
		textColor: normalized.textColor,
	};
}
